module.exports = __webpack_public_path__ + "img/headerLogo.5e7b3f03.png";